/**
 * Whether the dashboard is currently showing the internal chat route (browser only).
 */
export function internalChatPageVisibleInBrowser() {
  if (typeof window === 'undefined') return false;
  return window.location.pathname.includes('/internal-chat');
}

/**
 * True when the user is on internal chat and has this room open (eligible to skip unread/toast).
 * @param {object} internalChatState - namespaced internalChat Vuex module state
 * @param {number} roomId
 */
export function viewingInternalChatRoom(internalChatState, roomId) {
  if (!internalChatPageVisibleInBrowser()) return false;
  const active = internalChatState.activeRoomId;
  if (active == null) return false;
  return Number(active) === Number(roomId);
}
